<template>
    <div>
        <div class="flex flex-wrap -mx-4 gap-y-4 lg:gap-y-6">
            <card
                v-for="item in items"
                :key="item.id"
                :item="item"
                class="w-full md:w-1/2 xl:w-1/3"
            ></card>
        </div>
    </div>
</template>

<script>
import Card from "./Card.vue"

export default {
    name: "BirdsArchiveGrid",
    components: {
        Card,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        items() {
            return window?.capes?.[this.name]?.items ?? []
        },
    },
}
</script>
